export default __webpack_public_path__ + "static/media/cartoon-character-quiz_demo_image.a7e42378.png";